import React from 'react';

export function NumberingCDRDescription(): JSX.Element {
  return (
    <div className="alert alert-info">
      Antibody numbering is performed using the SAbPred/ANARCI library (
      <a href="https://academic.oup.com/bioinformatics/article/32/2/298/1743894">Dunbar and Deane, 2016</a>).
      ANARCI aligns each amino acid sequence to a set of Hidden Markov Models (HMMs) using HMMER3. Each HMM
      describes the putative germ-line sequences for a variable domain type (VH, Vλ, or Vκ for antibodies, Vα,
      Vβ, Vγ, or Vδ for T-cell receptors) of a particular species (Human, Mouse, Rat, Rabbit, Pig, Rhesus
      Monkey or Alpaca). The most significant alignment is then used to apply one of three numbering schemes
      (Kabat, Chothia, IMGT). These numberings are then the basis for identification of
      complementarity-determining (CDR) and framework regions (FR) according to the canonical sequence-based
      definitions of North, Chothia, Kabat, or IMGT.
    </div>
  );
}
